import { render, staticRenderFns } from "./SentenceMeaning.vue?vue&type=template&id=029484b4&"
import script from "./SentenceMeaning.vue?vue&type=script&lang=js&"
export * from "./SentenceMeaning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports